import type { DeadlineAssigneeCandidateDto, DeadlineAssigneeDto } from '@prospero/shared';

/** Una persona anonimizzata non è più tra i candidati: resta selezionata col suo segnaposto. */
export function withRemovedAssignee(
  candidates: readonly DeadlineAssigneeCandidateDto[],
  currentAssignee: DeadlineAssigneeDto | null,
  removedUserLabel: string,
): DeadlineAssigneeCandidateDto[] {
  const isCurrentAssigneeListed =
    currentAssignee !== null &&
    candidates.some((candidate) => candidate.userId === currentAssignee.userId);
  if (currentAssignee === null || isCurrentAssigneeListed) {
    return [...candidates];
  }
  return [
    ...candidates,
    { userId: currentAssignee.userId, name: currentAssignee.name ?? removedUserLabel },
  ];
}
